module.exports = __webpack_public_path__ + "img/user_default_img.4a072cc0.jpg";